// API Configuration
// This file centralizes all API endpoint configurations

// Backend server base URL
// Production: https://api.farmxapp.in (DigitalOcean Droplet with Ubuntu Server)
// Development: http://localhost:5000
// Domain: farmxapp.in (Hostinger)
// Backend: Deployed on DigitalOcean Droplet (IP: 64.227.184.84, Port: 5000)
// NOTE: Backend is already deployed and accessible at https://api.farmxapp.in
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.farmxapp.in/api';
const UPLOADS_BASE_URL = process.env.REACT_APP_UPLOADS_BASE_URL || 'https://api.farmxapp.in';

// Export API endpoints
export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    LOGIN: `${API_BASE_URL}/auth/login`,
    REGISTER: `${API_BASE_URL}/auth/register`,
    LOGOUT: `${API_BASE_URL}/auth/logout`,
    DELETE_ACCOUNT: `${API_BASE_URL}/auth/account`,
  },
  
  // Ad endpoints
  ADS: {
    BASE: `${API_BASE_URL}/ads`,
    GET_ALL: `${API_BASE_URL}/ads`,
    GET_BY_ID: (id) => `${API_BASE_URL}/ads/${id}`,
    CREATE: `${API_BASE_URL}/ads`,
    UPDATE: (id) => `${API_BASE_URL}/ads/${id}`,
    DELETE: (id) => `${API_BASE_URL}/ads/${id}`,
    MY_ADS: `${API_BASE_URL}/ads/my`,
    FAVOURITES: `${API_BASE_URL}/ads/favourites`,
    FAVORITE: (id) => `${API_BASE_URL}/ads/${id}/favorite`,
    NEARBY: `${API_BASE_URL}/ads/nearby`,
  },
};

// Helper function to get image URL
export const getImageUrl = (filename) => {
  // If it's already a full URL (Cloudinary or external), return as-is
  if (filename && (filename.startsWith('http://') || filename.startsWith('https://'))) {
    return filename;
  }
  // Otherwise, treat as filename and prepend uploads path
  return `${UPLOADS_BASE_URL}/uploads/${filename}`;
};

// Export base URLs for direct use if needed
export { API_BASE_URL, UPLOADS_BASE_URL };

export default API_ENDPOINTS;

